module.exports = __webpack_public_path__ + "img/Tools & Equip_Selected.809755bf.svg";